import React from "react"
import TypeformEmbed from "../common/TypeformEmbed"

const PrepaidDiscountTherapy = () => {
  return <TypeformEmbed id="ULApDFHu" />
}

export default PrepaidDiscountTherapy
